module.exports = __webpack_public_path__ + "img/لوکس.5a4bc5ce.png";